<div
  class="auto-complete-dropdown-container"
  [ngClass]="{ showing_suggestions: showSuggestions }"
>

  <div class="search-bar" [ngClass]="{ search_focused: focusSearch }" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <input
      autocomplete="off"
      type="search"
      name="search"
      [id]="id"
      [readOnly]="readonly"
      [placeholder]="placeholder"
      [(ngModel)]="searchTerm"
      (ngModelChange)="updateSearchTerm()"
      (focus)="onInputFocus()"
      (focusout)="onInputFocusOut()"
      (keyup.enter)="handleEnter($event)"
      (keyup.escape)="showSuggestions = false"
      [disabled]="disable"
      [ngClass]="{'form_error': hasError()}"
    />
    <app-svg-icon class="image-icon" [path]="'assets/icons/search_icon.svg'"></app-svg-icon>
    <div class="role_chips" *ngIf="multiSelect && selectedItems.size > 0">
      <div class="chip">
        <span>{{ selectedItems.size }} Item(s)</span>
        <span class="remove-chip" (click)="removeAllSelections()">&times;</span>
      </div>
    </div>
  </div>
  <ng-template
    cdk-connected-overlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="showSuggestions"
    [cdkConnectedOverlayPanelClass]="'autocomplete-overlay-panel'"
    [cdkConnectedOverlayWidth]="triggerWidth"
    [cdkConnectedOverlayHasBackdrop]="true"
    (overlayOutsideClick)="showSuggestions = false"
  >
    <div
      class="search-results"
      [ngClass]="{ search_focused: focusSearch }"
      (scroll)="onScroll($event)"
    >
      <!--<div
        class="result"
        *ngFor="let result of suggestions"
        (click)="select(result)"
      >
        <span *ngIf="result.name.trim() === ''"> N/A </span>
        <span
          *ngIf="result.name.trim() !== ''"
          [innerHTML]="result.name.trim() | highlight : searchTerm"
        ></span>

        <div class="hint">
          Code :
          <span [innerHTML]="result.code | highlight : searchTerm"></span>
        </div>
      </div>-->

      <table class="suggestions-table">
        <thead *ngIf="displayColumns.length > 1 && suggestions.length > 0">
        <tr>
          @if (multiSelect) {
            <th></th>
          }
          <th *ngFor="let column of displayColumns">{{ column.header }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let result of suggestions" (click)="select(result)">
          <td *ngIf="multiSelect" class="cb_td"><input type="checkbox" [checked]="result.selected"></td>
          <td *ngFor="let column of displayColumns">
            <!-- <span [innerHTML]="result[column.key] | highlight : searchTerm"></span> -->
            {{CommonUtils.getNestedValue(result, column.key)}}
          </td>
        </tr>
        <tr
          *ngIf="suggestions.length === 0 && allowCustomInput && searchTerm"
          (click)="selectCustomInput(); $event.stopPropagation()"
        >
          <td [attr.colspan]="displayColumns.length" class="custom-input-suggestion">
            Use "<strong>{{ searchTerm }}</strong>" as input
          </td>
        </tr>
        </tbody>
      </table>

      <div class="result loading_results" *ngIf="loading">Loading...</div>

      <div class="result no_results" *ngIf="suggestions.length === 0 && !loading && !allowCustomInput">
        No results!
      </div>
    </div>
  </ng-template>

  <!-- <cdk-virtual-scroll-viewport
    [itemSize]="50"
    [style.height.px]="calculateViewportHeight(suggestions.length)"
    class="search-results"
    [ngClass]="{ search_focused: focusSearch }"
    *ngIf="showSuggestions || (focusSearch && suggestions.length > 0)"
    (scrolledIndexChange)="onScroll()"
  >
    <div
      class="result"
      *ngFor="let result of suggestions"
      (click)="select(result)"
    >
      <span *ngIf="result.name.trim() === ''"> N/A </span>
      <span
        *ngIf="result.name.trim() !== ''"
        [innerHTML]="result.name.trim() | highlight : searchTerm"
      ></span>

      <div class="hint">
        Code :
        <span [innerHTML]="result.code | highlight : searchTerm"></span>
      </div>
    </div>

    <div class="result loading_results" *ngIf="loading">Loading...</div>

    <div class="result no_results" *ngIf="suggestions.length === 0 && !loading">
      No results!
    </div>
  </cdk-virtual-scroll-viewport> -->
</div>
